
import querystring from 'vux/src/tools/querystring/index.js'
import dateFormat from 'vux/src/tools/date/format.js'

export default {
  data() {
    return {
      liveId: ''
    }
  },
  methods: {
    login(to, from) {
      let url = querystring.parse(window.location.hash)
      if (url.access_token) {
        // 执行登录请求
        this.$store
          .dispatch({
            type: 'getCurrentUser',
            refresh_token: url.refresh_token
          })
          .then(() => {
            let user = this.$store.state.user.wechatInfo
            // 存储user
            window.localStorage.user = JSON.stringify(user)
            // 存储当前时间
            let now = dateFormat(new Date(), 'YYYY-MM-DD HH:mm:ss')
            window.localStorage.validDate = new Date()
            if (window.localStorage.beforeUrl) {
              window.location.href = window.localStorage.getItem('beforeUrl')
              window.localStorage.removeItem('beforeUrl')
            } else {
              if (window.localStorage.to) {
                let routers = JSON.parse(window.localStorage.to)
                window.location.href = window.location.origin + routers.path
                window.localStorage.removeItem('to')
              }
            }
          })
          .catch(err => {
            // 重新进行用户登录
            let redUrl = encodeURI(window.location.origin + '/login')
            let url = `https://wechatauth.aiyaopai.com/auth/clientside?appid=wx76b9a692b8709d44&redirect_uri=${redUrl}&response_type=code&scope=snsapi_userinfo&state=21`
            window.location.href = url
          })
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.login()
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/Login/Login.vue